(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prestige-products-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.pdReady) return;
      root.dataset.pdReady = '1';

      var track = root.querySelector('[data-pd-track]');
      var prev = root.querySelector('[data-pd-prev]');
      var next = root.querySelector('[data-pd-next]');
      if (!track || !prev || !next) return;

      function update() {
        var overflow = track.scrollWidth > track.clientWidth + 2;
        track.classList.toggle('is-centered', !overflow);
        prev.hidden = !overflow;
        next.hidden = !overflow;
        if (overflow) {
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        }
      }

      function step(direction) {
        var item = track.querySelector('.pd-strip__item');
        var width = item ? item.getBoundingClientRect().width : 300;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var perPage = Math.max(1, Math.floor(track.clientWidth / (width + gap)));
        track.scrollBy({ left: direction * (width + gap) * perPage, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      window.addEventListener('load', update);
    }

    function initAll() {
      document.querySelectorAll('[data-pd-strip]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
